import { render, staticRenderFns } from "./CertificateSuggestions.vue?vue&type=template&id=4d520ddc&scoped=true"
import script from "./CertificateSuggestions.vue?vue&type=script&lang=ts"
export * from "./CertificateSuggestions.vue?vue&type=script&lang=ts"
import style0 from "./CertificateSuggestions.vue?vue&type=style&index=0&id=4d520ddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d520ddc",
  null
  
)

export default component.exports